var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"6","height":"8","fill":"#974900","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M5.118 6.793L4.41 7.5.875 3.964 4.411.43l.707.707-2.829 2.828 2.829 2.829z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }